import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { usuarioTieneFirma, usuarioTieneRegistro } from "../../../resources/Helper";

function ListarPacientes() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [permisos, setPermisos] = useState([]);
    const [showModalCompletarInfo, setShowModalCompletarInfo] = useState(false);
    let userdata = [];
    let clientData = [];
    let history = useHistory();

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [showToast, setShowToast] = useState(false);

    const getNombreCompleto = (row) => {
        return row.primer_nombre + ' ' + getNombre(row.segundo_nombre) + ' ' + row.primer_apellido + ' ' + getNombre(row.segundo_apellido);
    }

    const cols = [
        { 
            name: 'Nombre', 
            selector: row => getNombreCompleto(row), 
            sortable: true,
            cell: row => <span title={getNombreCompleto(row)}>{getNombreCompleto(row)}</span>
        },
        { name: 'Documento', selector: row => row.numero_documento, sortable: false, maxWidth: '14%' },
        { name: 'Email', selector: row => row.email, sortable: false },
        { name: 'Celular', selector: row => row.celular, sortable: false },
        { name: 'Acción', cell: row => getBotones(row), minWidth: '32%' }
    ];

    const getNombre = (nombre) => {
        return nombre != null ? nombre : '';
    }

    const getBotones = (item) => {
        const etiquetaBotonEditar = item.estado != '0' ? 'Editar' : 'Completar datos';
        const btnEditarPaciente = permisos.includes('crearPacientes') ? <Link to={'/editar-paciente?id=' + item.id} className="btn btn-secondary btn-sm" style={{ 'marginRight': '8px' }} title={etiquetaBotonEditar}><i className="far fa-edit"></i>&nbsp;Editar</Link> : <></>
        
        // Botón Estado de Cuenta (Cartera)
        const btnEstadoCuenta = <Link to={'/estado-cuenta-paciente?id=' + item.id} className="btn btn-info btn-sm" style={{ 'marginRight': '8px' }} title="Ver estado de cuenta del paciente"><i className="fas fa-dollar-sign"></i>&nbsp;Cartera</Link>;
        
        //let btnAtenderPaciente = permisos.includes('atenderPacientes') ? <Link to={'/atender-paciente?id='+item.id} className="btn btn-primary btn-sm"><i className="fas fa-user-md"></i>&nbsp;Atender paciente</Link> : <></>
        let btnAtenderPaciente = permisos.includes('atenderPacientes') ? <button onClick={() => setShowModalCompletarInfo(true)} className="btn btn-success btn-sm" title="Atender paciente"><i className="fas fa-user-md"></i>&nbsp;Atención</button> : <></>

        let user = JSON.parse(localStorage.getItem('userdata'));

        if (user.firma && user.registro) {
            btnAtenderPaciente = permisos.includes('atenderPacientes') ? <Link to={'/atender-paciente?id=' + item.id} className="btn btn-success btn-sm" title="Atender paciente"><i className="fas fa-user-md"></i>&nbsp;Atención</Link> : <></>
        }

        const btnsPacienteIncompleto = [btnEditarPaciente, btnEstadoCuenta];
        const btnsPacienteCompleto = [btnEditarPaciente, btnEstadoCuenta, btnAtenderPaciente];

        return item.estado != '0' ? btnsPacienteCompleto : btnsPacienteIncompleto;
    }

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true); // ✅ Marcar como cargado para mostrar Unauthorized
            return; // Detener si no hay datos de usuario
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        setPermisos(userdata.up || []);

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a listar pacientes
        const tienePermiso = userdata.up && userdata.up.includes('crearPacientes');

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true); // ✅ Marcar como cargado para mostrar Unauthorized
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsername(userdata.user_name);

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {

                console.log(error);
            });

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe ver solo sus pacientes
        const esProfesionalIndependiente = userdata.up && userdata.up.includes('profesionalIndependiente');
        const parametrosFiltro = {
            uid: userdata.user_id,
            solo_pacientes: true // 🆕 Filtrar solo pacientes (tipo_cliente = 0 o null), no empresas
        };

        // Si es profesional independiente, agregar filtro por usuario
        if (esProfesionalIndependiente) {
            parametrosFiltro.solo_mis_pacientes = true;
            console.log('Usuario es Profesional Independiente - Mostrando solo sus pacientes');
        } else {
            console.log('Usuario puede ver todos los pacientes del cliente');
        }

        axios.get('/pacientes', { params: parametrosFiltro })
            .then(response => {
                if (response.status === 200) {
                    setItems(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }, []);


    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            return; // No hacer nada si no hay datos de usuario
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🆕 PROFESIONAL INDEPENDIENTE - Aplicar filtro también en búsqueda
        const esProfesionalIndependiente = userdata.up && userdata.up.includes('profesionalIndependiente');
        const parametrosBusqueda = {
            uid: userdata.user_id,
            termino: terminoBusqueda,
            solo_pacientes: true // 🆕 Filtrar solo pacientes (tipo_cliente = 0 o null), no empresas
        };

        // Si es profesional independiente, agregar filtro por usuario
        if (esProfesionalIndependiente) {
            parametrosBusqueda.solo_mis_pacientes = true;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        axios.get('/pacientes', { params: parametrosBusqueda })
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    }, [terminoBusqueda]);

    const handleCloseModalInfo = () => setShowModalCompletarInfo(false);
    const handleCompletarInfo = () => history.push('/configuracion');

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Pacientes</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Listar Pacientes</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Pacientes</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">


                            <div className="row">
                                <div className="col-md-9" style={{ display: 'flex', alignItems: 'center' }}>
                                    {permisos.includes('crearPacientes') &&
                                        <Link to={'/crear-paciente'} className={'btn btn-success'}>Crear nuevo</Link>
                                    }
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="terminoBusqueda">Buscar paciente</label>
                                        <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12" style={{ boxShadow: '0 0 14px rgba(0,0,0,0.09)', backgroundColor: 'white' }}>

                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        pagination
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'Filas por página',
                                            rangeSeparatorText: 'de',
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: 'Todos',
                                        }}
                                        noDataComponent="No hay registros para mostrar"
                                        id={'tabla-pacientes'}
                                    />

                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                <Modal show={showModalCompletarInfo} onHide={handleCloseModalInfo}>
                    <Modal.Header closeButton>
                        <Modal.Title>Aún no puedes atender citas</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Para atender una cita debes completar la siguiente información:</p>
                        <ul>
                            {!usuarioTieneFirma() ? <li>Firma</li> : <></>}
                            {!usuarioTieneRegistro() ? <li>Registro médico</li> : <></>}
                        </ul>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModalInfo}>Cancelar</Button>
                        <Button variant="primary" onClick={handleCompletarInfo}>Completar información</Button>
                    </Modal.Footer>
                </Modal>

                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default ListarPacientes;